import { useContext } from 'react';

import LipidStocksContext from '../../context/materialcapture/LipidStocksContext';

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import SendSharpIcon from '@mui/icons-material/SendSharp';
import FormControl from '@mui/material/FormControl';

const LipidStocksForm = () => {
  const { 
    lipidStocksData, setLipidStocksData, handleSubmit, initialValues, formErrors
  } = useContext(LipidStocksContext);

  return(
    <Grid container spacing={1} mt={1}>
      <Grid item xs={12}>
        <Autocomplete
          multiple
          value={lipidStocksData?.lipidAliquotsArray}
          onChange={(e, newValue) => 
            setLipidStocksData(prev => ({
              ...prev,
              lipidAliquotsArray: newValue,
            }))
          }
          options={initialValues?.lipidAliquotsArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Lipid Aliquots *" 
              placeholder="Type to search Lipid Aliquots..." 
              error={'lipidAliquots' in formErrors}
              helperText={formErrors['lipidAliquots']}
            />
          )}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Unique lipid stock ID *"
          name='lipdStockId'
          value={lipidStocksData?.lipdStockId}
          onChange={e => 
            setLipidStocksData(prev => ({
              ...prev,
              lipdStockId: e.target.value
            }))
          }
          helperText={formErrors['lipdStockId']}
          error={'lipdStockId' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidStocksData?.solvent}
          onChange={(e, newValue) => 
            setLipidStocksData(prev => ({
              ...prev,
              solvent: newValue
            }))
          }
          onInputChange={(e, newValue) =>
            setLipidStocksData(prev => ({
              ...prev,
              solvent: newValue
            }))
          }
          options={initialValues?.solventArray}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Solvent *" 
              placeholder="Type to search Solvent..." 
              error={'solvent' in formErrors}
              helperText={formErrors['solvent']}
            />
          )}
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Concentration (mg/mL) *"
          name='concentration'
          value={lipidStocksData?.concentration}
          onChange={e => 
            setLipidStocksData(prev => ({
              ...prev,
              concentration: e.target.value
            }))
          }
          type='number'
          helperText={formErrors['concentration']}
          error={'concentration' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <FormControl fullWidth>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label='Date prepared *'
              name='datePrepared'
              value={lipidStocksData?.datePrepared} 
              onChange={e => 
                setLipidStocksData(prev => ({
                  ...prev,
                  datePrepared: e
                }))
              } 
              maxDate={initialValues?.today}
              renderInput={(params) => 
                <TextField 
                  {...params} 
                  error={Boolean(formErrors['datePrepared'])}
                  helperText={formErrors['datePrepared']}
                />
              }
            />
          </LocalizationProvider>
        </FormControl>
      </Grid>

      <Grid item xs={6}>
        <Autocomplete
          value={lipidStocksData?.operatorArray || []}
          onChange={(e, newValue) => 
            setLipidStocksData(prev => ({
              ...prev,
              operatorArray: newValue
            }))
          }
          onInputChange={(e, newInputValue, reason) => {
            if (reason === "createOption" && newInputValue.trim()) {
              setLipidStocksData((prev) => ({
                ...prev,
                operatorArray: [
                  ...(prev.operatorArray || []),
                  newInputValue
                ],
              }));
            }
          }}
          options={initialValues?.operatorArray || []}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label="Operator *" 
              placeholder="Type to search Operator..." 
              error={'operator' in formErrors}
              helperText={formErrors['operator']}
            />
          )}
          multiple
          freeSolo
          fullWidth
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          varient="outlined"
          label="Amount prepared (mL) *"
          name='amountPrepared'
          value={lipidStocksData?.amountPrepared}
          onChange={e => 
            setLipidStocksData(prev => ({
              ...prev,
              amountPrepared: e.target.value
            }))
          }
          type='number'
          helperText={formErrors['amountPrepared']}
          error={'amountPrepared' in formErrors}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Stack direction="row" spacing={1} justifyContent="flex-end" mr={1}>
          <Button 
            variant="contained" 
            endIcon={<SendSharpIcon />} 
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default LipidStocksForm;